import React, { useMemo } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { Translation as T, useAmsSelector } from "@awe-web/shared/lib";
import { Flag } from "../../components/flag.js";
import { getSelectedRentObject } from "../store.js";

import airConditionIcon from "./assets/air-condition.svg";
import minimumAgeIcon from "./assets/minimum-age.svg";
import navigationSystemIcon from "./assets/navigation-system.svg";
import seatingCapacityIcon from "./assets/seating-capacity.svg";
import cellPhoneIntegrationIcon from "./assets/cell-phone-integration.svg";

import "./selected_rent_object.scss";

const AIR_CONDITIONING = "FSD0000115";
const NAVIGATION_SYSTEM = "FSD0000116";
const SEATING_CAPACITY = "FSD0000117";
const MINIMUM_AGE = "FSD0000118";
const CELL_PHONE_INTEGRATION = "ALG0000028";

export default function SelectedRentObject({ className, selectedBasicProperties, action }) {
  const rentObject = useAmsSelector(getSelectedRentObject);
  const localRentObject = useMemo(() => rentObject ? rentObject.toJS() : {}, [rentObject]);
  const combinedClassName = classnames("selected-rent-object", className);

  return (
    <div className={combinedClassName}>
      <div className="selected-rent-object__rent-object" >
        <img className="selected-rent-object__rent-object__image" src={localRentObject.imageUrl1} alt={localRentObject.description} />
        <span className="selected-rent-object__rent-object__name">{localRentObject.description}</span>
      </div>

      {
        /*
         * We don't use <RentObjectBasicProperties> here because the
         * positioning is slightly different and the icons have a
         * different size
         */
      }
      <ul className="selected-rent-object__details">
        <li className="selected-rent-object__feature">
          <div className="rent-object-feature-type">
            <img className="rent-object-feature-type__image" src={airConditionIcon} alt="" />
            <T code={AIR_CONDITIONING} />
          </div>
          <div className="rent-object-feature-value"><Flag flag={localRentObject.hasAirCondition} /></div>
        </li>

        <li className="selected-rent-object__feature">
          <div className="rent-object-feature-type">
            <img className="rent-object-feature-type__image" src={navigationSystemIcon} alt="" />
            <T code={NAVIGATION_SYSTEM} />
          </div>
          <div className="rent-object-feature-value"><Flag flag={localRentObject.hasNavigationSystem} /></div>
        </li>

        <li className="selected-rent-object__feature">
          <div className="rent-object-feature-type">
            <img className="rent-object-feature-type__image" src={seatingCapacityIcon} alt="" />
            <T code={SEATING_CAPACITY} />
          </div>
          <div className="rent-object-feature-value">{localRentObject.numberOfSeats}</div>
        </li>

        {selectedBasicProperties === "B2C" && (
          <li className="selected-rent-object__feature">
            <div className="rent-object-feature-type">
              <img className="rent-object-feature-type__image" src={minimumAgeIcon} alt="" />
              <T code={MINIMUM_AGE} />
            </div>
            <div className="rent-object-feature-value">{localRentObject.minDriverAge}</div>
          </li>
        )}

        {selectedBasicProperties === "B2B" && (
          <li className="selected-rent-object__feature">
            <div className="rent-object-feature-type">
              <img className="rent-object-feature-type__image" src={cellPhoneIntegrationIcon} alt="" />
              <T code={CELL_PHONE_INTEGRATION} />
            </div>
            <div className="rent-object-feature-value"><Flag flag={localRentObject.hasCellPhoneIntegration} /></div>
          </li>
        )}
      </ul>

      {action
        ? <div className="selected-rent-object__action">{action}</div>
        : null
      }
    </div>
  );
}

SelectedRentObject.propTypes = {
  className: PropTypes.string,
  selectedBasicProperties: PropTypes.oneOf(["B2C", "B2B"]).isRequired,
  action: PropTypes.node
};
